export default __webpack_public_path__ + "fonts/inter-latin-300-normal.71cb4fb821268a11c81b.woff2";